import { ORDER_API_TIMEOUT_THRESHOLD } from 'constants/constants';
import {
  CONTENT_API_KEY,
  CONTENT_API_URL,
  NEXT_PUBLIC_BFF_URL,
  RETAILER_API_KEY,
  RETAILER_API_URL,
} from 'constants/runtimeConfig';
import apiFactory from 'services/api/axios';

export function createRetailerApiFetcher(jwt) {
  const fetcher = apiFactory({
    baseURL: RETAILER_API_URL,
    headers: {
      Authorization: jwt,
      'x-api-key': RETAILER_API_KEY,
    },
    timeout: ORDER_API_TIMEOUT_THRESHOLD,
  });

  return fetcher;
}

export function createContentApiFetcher() {
  const fetcher = apiFactory({
    baseURL: CONTENT_API_URL,
    headers: {
      'x-api-key': CONTENT_API_KEY,
    },
  });

  return fetcher;
}

/**
 *
 * @param {string} jwt  jwt token
 * @returns {AxiosInstance} creates a fetcher for /search/search routes
 */
export function createSearchFetcher(jwt) {
  const fetcher = apiFactory({
    baseURL: `${NEXT_PUBLIC_BFF_URL}/search/search`,
    headers: {
      Authorization: jwt,
    },
  });

  return fetcher;
}

export function createGuestApiFetcher() {
  const fetcher = apiFactory({
    baseURL: RETAILER_API_URL,
    headers: {
      'x-api-key': RETAILER_API_KEY,
    },
  });

  return fetcher;
}

export function getBody(event) {
  return JSON.parse(event.body && (typeof event.body === 'string' ? event.body : JSON.stringify(event.body)));
}

export function getJWTFromRequest({ headers }) {
  return headers.authorization;
}
